import { Button, Input, TableProps } from "antd";
import { Link } from "react-router-dom";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import ViewIcon from "../../../../assets/icons/ViewIcon";
import CustomTable from "../../../../components/ui/CustomTable";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../../utils/number";

export default function History() {
  const { page, limit, handlePagination, handleLimit } = useTable();

  const columns: TableProps<DataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: <div className="whitespace-nowrap !w-[120px]">Batch Name</div>,
      dataIndex: "batchName",
    },
    {
      title: <span className="whitespace-nowrap">Number of Employees</span>,
      align: "center",
      dataIndex: "numberOfEmployees",
    },
    {
      title: <span className="whitespace-nowrap">Amount (BDT)</span>,
      align: "center",
      dataIndex: "amount",
    },
    {
      title: <span className="whitespace-nowrap">Uploaded By</span>,
      dataIndex: "uploadedBy",
    },
    {
      title: <span className="whitespace-nowrap">Checked By</span>,
      dataIndex: "checkedBy",
    },
    {
      title: <span className="whitespace-nowrap">Approved By</span>,
      dataIndex: "approvedBy",
    },
    {
      title: <div className="whitespace-nowrap !w-[110px]">Status</div>,
      dataIndex: "status",
      align: "center",
      render: (value: DataType["status"]) => (
        <span
          className={`px-2 py-1 rounded text-xs font-medium ${
            value === "Complete"
              ? "bg-green-100 text-green-700"
              : "bg-yellow-100 text-yellow-700"
          }`}
        >
          {value}
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val) => (
        <div className="flex justify-center items-center gap-2">
          <Link to={`/admin/salary-disbursement/history/history-details/${1}`}>
            <Button
              className="action-button !w-[80px]"
              size="small"
              icon={<ViewIcon />}
            >
              Open
            </Button>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      <SidebarLayout title="Disbursement History">
        <CustomTable
          loading={false}
          limit={limit}
          page={page}
          columns={columns}
          total={120} // Update total as per the data
          dataSource={data}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              <Input
                suffix={<SearchIcon />}
                placeholder="Search"
                style={{ width: 220 }}
                allowClear
              />
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}

interface DataType {
  id: number | string;
  batchName: string;
  numberOfEmployees: number;
  amount: number;
  uploadedBy: string;
  checkedBy: string;
  approvedBy: string;
  status: "Complete" | "Partially Settled";
}

const data: DataType[] = [
  {
    id: 1,
    batchName: "January Batch",
    numberOfEmployees: 25,
    amount: 5000,
    uploadedBy: "Alice",
    checkedBy: "Bob",
    approvedBy: "Charlie",
    status: "Complete",
  },
  {
    id: 2,
    batchName: "February Batch",
    numberOfEmployees: 18,
    amount: 3600,
    uploadedBy: "David",
    checkedBy: "Eva",
    approvedBy: "Frank",
    status: "Complete",
  },
];
